// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf6579ed","239":"58a757ce","455":"379fe3d2"}[chunkId] + ".chunk.js";
};